import { useSearchParams } from "react-router-dom";
import EmptyIcon from "../assets/empty.svg";

function ErrorPage() {
    const [searchParams] = useSearchParams();
    const errorId = searchParams.get("id");
    return (
        <div style={{ width: '450px', wordWrap: 'break-word', alignContent: 'center', placeSelf: 'anchor-center', textAlign: 'center' }}>
            <div>
                <img src={EmptyIcon}></img>
            </div>
            <div style={{ fontSize: '24px', fontWeight: '500' }}>
                <h1>Error</h1>
                {
                    errorId === '500' ? <h2>Internal error</h2> :
                    errorId === '404' ? <h2>Not found</h2> :
                    errorId === 'x' ? <h2>Component error</h2> :
                    <h2>Generic error {errorId}</h2>
                }
            </div>
        </div>
  );
}

export default ErrorPage;